import { Grid, Typography } from "@mui/material";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";

export default function ThankYou() {
  return (
    <Grid
      container
      style={{
        backgroundColor: "#FFFFFF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: 28,
      }}>
      <Grid item xs={12}>
        <CheckCircleOutlineOutlinedIcon sx={{ color: "Green", fontSize: "70px" }} />
      </Grid>
      <Grid item xs={12}>
        <Typography fontSize={"16px"} sx={{ fontWeight: 600, textAlign: "center" }}>
          Thank You!
        </Typography>
        <Typography fontSize={"16px"} sx={{ fontWeight: 600, textAlign: "center" }}>
          Your information has been submitted successfully
        </Typography>
      </Grid>
    </Grid>
  );
}
